import { z } from 'zod';
/**
 * Auth request/response contracts, shared by the API and the frontend.
 *
 * Living in @rhcst/shared means the browser validates against exactly the same
 * rules the server enforces, so a client-side change cannot drift from the
 * server contract.
 */
export const loginRequestSchema = z.object({
    email: z.string().trim().toLowerCase().email('Enter a valid email address').max(320),
    // Only a length range is enforced on login. Composition rules belong at
    // password *creation* time; applying them here would reject a legitimate
    // strong password and advertise the policy to an attacker.
    password: z.string().min(1, 'Password is required').max(1024),
});
/** Password rules applied when a password is set or changed. */
export const passwordSchema = z
    .string()
    .min(12, 'Use at least 12 characters')
    .max(1024, 'Too long');
export const sessionUserSchema = z.object({
    id: z.string().uuid(),
    email: z.string().email(),
    role: z.enum(['admin', 'operator']),
});
//# sourceMappingURL=auth.js.map